// Splits a line into sentences for Edit, at a full stop, question mark or exclamation
// mark followed by a capital. A list number ("1. Booking and services") is not the end
// of a sentence, so numbered headings and steps stay whole.
export function splitSentences(line) {
  return line.split(/(?<!(?:^|\s|#)\d{1,3}\.)(?<=[.?!])\s+(?=[A-Z])/g);
}
